// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3Us7q","header":"ReportDetails_header__OguaI","title":"ReportDetails_title__1tMzR","left":"ReportDetails_left__2gOWe"};